import React, { Component } from 'react';
import { Modal, Input, Form } from 'antd';

import { ItemTypes } from '../../../../constants/constants';
import _ from 'lodash';

import { showRenameSelectedFilesModal } from '../../../../../../shared/utils/files/upload-helper';

export default class RenameDialog extends Component {
  state = {
    loading: false,
  };

  constructor(props) {
    super(props);
  }

  formRef = React.createRef();

  handleSubmitRename = () => {
    this.formRef.current
      .validateFields()
      .then(async (values) => {
        const fullFileName = values.name.trim() + this.props.extension;
        this.setState({ loading: true });
        let existingFiles = await this.props.beforeSubmit(fullFileName);

        if (existingFiles?.length) {
          const existingfileNames = _.uniqBy(existingFiles, 'name').map((x) => x.name);

          showRenameSelectedFilesModal(
            existingfileNames,
            this.props.rootContainer,
            async (close) => {
              this.setState({ loading: false });
              return await this.props.onSubmit(fullFileName).then(async (_) => {
                this.formRef.current?.resetFields();
                await this.props.afterSubmit();
                close();
              });
            },
            () => {
              this.setState({ loading: false });
            },
          );
        } else {
          return await this.props.onSubmit(fullFileName).then(async (_) => {
            this.setState({ loading: false });
            this.formRef.current?.resetFields();
            await this.props.afterSubmit();
          });
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
        this.setState({ loading: false });
      });
  };

  render() {
    const { onHide, initialValue, rootContainer, resourceType, extension } = this.props;

    return (
      <Modal
        title={`Rename ${resourceType === ItemTypes.Directory ? 'folder' : 'file'}`}
        getContainer={rootContainer}
        width="520px"
        open={true}
        okText="Confirm"
        cancelText="Cancel"
        onCancel={onHide}
        confirmLoading={this.state.loading}
        onOk={this.handleSubmitRename}
      >
        <Form
          ref={this.formRef}
          layout="horizontal"
          initialValues={{
            name: initialValue,
          }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter name.',
              },
              {
                pattern: /^[a-zA-Z0-9\ \!\-_\.\,\*'\(\)]+$/,
                message: "Name can contain only letters, numbers, spaces and following symbols - '!-_.,*()'",
              },
              ({}) => ({
                validator: (_, value) =>
                  value.length >= 255 ? Promise.reject('The name is too long. It can be max 255 symbols long.') : Promise.resolve(),
              }),
            ]}
          >
            <Input autoFocus addonAfter={extension} placeholder="Please enter new name" ref={(input) => input && input.focus()} />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}
